import { useState } from "react";
import ModalCreateUpdateQuestion from "../ModalCreateUpdateQuestion"
import styles from "./styles.module.css";

export default function QuestionCreateButton({ collectionRef, updateTableData }) {

    const [modal, setModal] = useState(false);

    return (<>

        <div className={styles.buttonContainer}>
            <button onClick={() => { setModal(true) }} className={styles.createButton}>Nova Pergunta</button>
        </div>

        {modal && <ModalCreateUpdateQuestion updateTableData={updateTableData} setModal={setModal} collectionRef={collectionRef} update={false} />}

    </>)
}